<template lang="pug">
  div.mt-1
    el-row(type='flex')
      el-col(:span="8").container-input
        app-label(label="Nome do documento:", :required="false")
        el-input.input.ellipsis(
          v-model="documento.nome",
          disabled=true
        )

      el-col(:span="8").container-input
        app-label(label="Tipo de documento:", :required="false")
        el-input.input.ellipsis(
          v-model="documento.tipo.nome",
          disabled=true
        )

      el-col(:span="8").container-input
        app-label(label="Data de envio:", :required="false")
        el-input.input(
          v-model="dataEnvioFormatada",
          disabled=true
        )

    el-row(type='flex')
      el-col(:span="8").container-input
        app-label(label="Responsável(eis):", :required="false")
        app-card-disabled
          list-responsavel-assinatura(:assinadores="documento.assinadores")

      el-col(:span="8").container-input
        div( v-if="datasAssinatura && documento.jaAssinadoPorPeloMenosPorUmaPessoa")
          app-label(label="Datas de assinatura:", :required="false")
          app-card-disabled
            .item-list(v-for="dataAssinatura in datasAssinatura")
              span {{dataAssinatura}}
      el-col(:span="8").container-input
</template>

<script>
import AppLabel from '@/components/AppLabel'
import Utils from '@/utils/utils'
import AppCardDisabled from '@/components/AppCardDisabled'
import ListResponsavelAssinatura from '@/screens/assinatura/components/ListResponsavelAssinatura'

export default {
  components: {
    AppLabel,
    AppCardDisabled,
    ListResponsavelAssinatura
  },

  props: {
    documento: {
      type: Object,
      required: true
    }
  },

  computed: {
    dataEnvioFormatada () {
      if (!this.documento.dataEnvio) return '--/--/--'

      return Utils.formatDate(this.documento.dataEnvio)
    },

    datasAssinatura () {
      if (!this.documento.assinadores) return null
      const listaDatas = []
      this.documento.assinadores.forEach(assinador => {
        listaDatas.push(assinador.dataAssinatura ? Utils.formatDate(assinador.dataAssinatura) : '--/--/--')
      })

      return listaDatas
    }
  }
}

</script>

<style lang="scss" scoped>
@import "@/assets/styles/element-variables.scss";

.container-input {
  margin-right: 20px;
}
</style>

<style lang="scss">
.ellipsis {
  input {
    text-overflow: ellipsis !important;
    white-space: nowrap !important;
    overflow: hidden !important;
  }
}

.item-list {
  padding:5px;
}
</style>



// WEBPACK FOOTER //
// src/screens/assinatura/components/DadosDocumento.vue